import React, { FC, useContext } from 'react';

import { Input } from '@smartshell/ui-kit';
import { Controller } from 'react-hook-form';

import { LocalizationContext } from 'localization';

import s from '../../../TinkoffModal.module.scss';
import { IFormBlockRequisitesProps } from '../interfaces';
import { getIsCorrectCode } from '../utils';

export const Requisites: FC<IFormBlockRequisitesProps> = ({ control, tab }) => {
  const { t } = useContext(LocalizationContext);
  const isCorrectCode = getIsCorrectCode(t);

  return (
    <div className={s.form__block}>
      <span className={s.title}>
        Реквизиты организации для вывода (На карту физлица средства вывести
        нельзя!)
      </span>
      <Controller
        render={({ field, fieldState: { error } }) => (
          <Input {...field} error={error?.message} title="Наименование банка" />
        )}
        name="bank_name"
        control={control}
        rules={{ required: t('errors.required') }}
      />
      <Controller
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            error={error?.message}
            title="БИК банка"
            mask="999999999"
          />
        )}
        name="bank_bik"
        control={control}
        rules={{ required: t('errors.required'), validate: isCorrectCode }}
      />
      <Controller
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            error={error?.message}
            title="Корреспондентский счет"
            mask="99999999999999999999"
          />
        )}
        name="correspondent_account"
        control={control}
        rules={{ required: t('errors.required'), validate: isCorrectCode }}
      />
      <Controller
        render={({ field, fieldState: { error } }) => (
          <Input
            {...field}
            error={error?.message}
            title="Расчетный счет получателя"
            mask="99999999999999999999"
          />
        )}
        name="bank_account"
        control={control}
        rules={{ required: t('errors.required'), validate: isCorrectCode }}
      />
      {tab === 'UL_RESIDENT' && (
        <Controller
          render={({ field, fieldState: { error } }) => (
            <Input
              {...field}
              error={error?.message}
              title="КПП"
              mask="999999999"
            />
          )}
          name="bank_kpp"
          control={control}
          rules={{ required: t('errors.required'), validate: isCorrectCode }}
        />
      )}
    </div>
  );
};
